/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } from "react";
import { fetch } from "@fyresite/fetch";

import TextInput from "@fyresite/react-textinput";
import Button from "../../../components/Button";
import moment from "moment";
class AddMember extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            firstName: {
                value: "",
                valid: "",
            },
            lastName: {
                value: "",
                valid: "",
            },
            dateOfBirth: {
                value: moment(),
                valid: true,
            },
            // gender: {
            //     value: "X",
            //     valid: true,
            // },
            nordIdentifier: {
                value: "",
                valid: "",
            },
        };
        this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleInputKeyPress);
    }
    componentWillMount() {
        document.addEventListener("keydown", this.handleInputKeyPress);
    }
    handleInputKeyPress(e) {
        if (e.key && e.key.toLowerCase() === "enter") {
            this.handleSubmit(e);
        }
    }

    onChange(field, e, inputState) {
        let state = Object.assign({}, this.state);

        state[field] = Object.assign({}, state[field], inputState);

        this.setState((prevState, props) => {
            return state;
        });
    }

    onRadioChange(field, e) {
        let value = e.target.value;
        let stateField = this.state[field];

        stateField.value = value;
        stateField.valid = true;

        this.setState((prevState, props) => {
            return {
                [field]: stateField,
            };
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let state = JSON.parse(JSON.stringify(this.state));
        for (var x = 0; x < Object.keys(state).length; x++) {
            let key = Object.keys(state)[x];

            if (!state[key].valid) {
                Materialize.toast(
                    `Please make sure that the ${key} is valid`,
                    4000,
                    "red"
                );
                return;
            }
        }

        fetch("/api/v1/member/create", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                firstName: this.state.firstName.value,
                lastName: this.state.lastName.value,
                dateOfBirth: this.state.dateOfBirth.value,
                gender: "X",
                nordIdentifier: this.state.nordIdentifier.value,
            }),
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    Materialize.toast(`Member was registered`, 4000, "green");
                    if (
                        json.result &&
                        json.result.member &&
                        json.result.member.id
                    ) {
                        this.props.history.push(
                            `/dashboard/enroll-member/${json.result.member.id}`
                        );
                    } else {
                        this.props.history.push("/dashboard/");
                    }
                } else {
                    Materialize.toast(
                        `Error occurred, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Error occurred, ${err}`, 4000, "red");
            });
    }

    render() {
        return (
            <div className="add-member">
                <div className="add-member-inner">
                    <h4>Add Member</h4>
                    <div className="card-container card-wrapper">
                        <div
                            className="form-card card z-depth-5"
                            ref="form-card"
                        >
                            <div className="card-content">
                                <form
                                    onSubmit={this.handleSubmit.bind(this)}
                                    className="left-align"
                                    noValidate
                                >
                                    <TextInput
                                        ref={(input) =>
                                            (this.firstName = input)
                                        }
                                        className=""
                                        inputClassName=""
                                        id="firstName"
                                        label="First Name"
                                        error="Please enter a first name"
                                        type="text"
                                        onChange={this.onChange.bind(
                                            this,
                                            "firstName"
                                        )}
                                        value={this.state.firstName.value}
                                        valid={this.state.firstName.valid}
                                        validator={(val) => {
                                            return val.length > 1;
                                        }}
                                    />
                                    <TextInput
                                        ref={(input) => (this.lastName = input)}
                                        className=""
                                        inputClassName=""
                                        id="lastName"
                                        label="Last Name"
                                        error="Please enter a last name"
                                        type="text"
                                        onChange={this.onChange.bind(
                                            this,
                                            "lastName"
                                        )}
                                        valid={this.state.lastName.valid}
                                        value={this.state.lastName.value}
                                        validator={(val) => {
                                            return val.length > 1;
                                        }}
                                    />
                                    <TextInput
                                        ref={(input) =>
                                            (this.dateOfBirth = input)
                                        }
                                        className=""
                                        inputClassName=""
                                        id="dateOfbirth"
                                        label="Date Of Birth"
                                        error="Please enter a Date of Birth"
                                        type="date"
                                        onChange={this.onChange.bind(
                                            this,
                                            "dateOfBirth"
                                        )}
                                        value={moment(
                                            this.state.dateOfBirth.value
                                        )
                                            .utc()
                                            .format("YYYY-MM-DD")}
                                        valid={this.state.dateOfBirth.valid}
                                        validator={(val) => {
                                            return val.length > 1;
                                        }}
                                    />
                                    {/*<div>
                    <p>{"Gender"}</p>
                    <div className="radios">
                      <div>
                        <input
                          type="radio"
                          id={`gender-male`}
                          checked={this.state.gender.value === "Male"}
                          value={"Male"}
                          onChange={this.onRadioChange.bind(this, "gender")} />
                        <label htmlFor={`gender-male`}>Male</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id={`gender-female`}
                          checked={this.state.gender.value === "Female"}
                          value={"Female"}
                          onChange={this.onRadioChange.bind(this, "gender")} />
                        <label htmlFor={`gender-female`}>Female</label>
                      </div>
                    </div>
                  </div>*/}
                                    <TextInput
                                        ref={(input) =>
                                            (this.nordIdentifier = input)
                                        }
                                        className=""
                                        inputClassName=""
                                        label="NORD Member Identifier"
                                        type="text"
                                        onChange={this.onChange.bind(
                                            this,
                                            "nordIdentifier"
                                        )}
                                        value={this.state.nordIdentifier.value}
                                        valid={this.state.nordIdentifier.valid}
                                        validator={(val) => {
                                            return val.length > 1;
                                        }}
                                        error=""
                                    />
                                    <Button
                                        color={"red"}
                                        flat={false}
                                        onClick={this.handleSubmit.bind(this)}
                                        z-depth={1}
                                    >
                                        {"Continue"}
                                    </Button>
                                    <Button
                                        color={null}
                                        flat={true}
                                        onClick={(e) =>
                                            this.props.history.push(
                                                "/dashboard/search-member"
                                            )
                                        }
                                        z-depth={1}
                                    >
                                        {"Back"}
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddMember;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/AddMember/AddMember.js